/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The platform of the meeting
 */
export type ListScheduledBotsResponseDataItemMeetingPlatform =
  (typeof ListScheduledBotsResponseDataItemMeetingPlatform)[keyof typeof ListScheduledBotsResponseDataItemMeetingPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListScheduledBotsResponseDataItemMeetingPlatform = {
  zoom: "zoom",
  meet: "meet",
  teams: "teams"
} as const
